module.exports = __webpack_public_path__ + "media/performancemotor_desktop_2.e1e3c304.mp4";